<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <validation-observer
        ref="formValidator"
        v-slot="{ handleSubmit }"
      >
        <b-form
          class="auth-login-form mt-2"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          <!-- Password เก่า -->
          <b-form-group
            :label="$t('passwordold')"
            label-for="password-old"
            class="input-text"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Old Password"
              :rules="{ required: true, min: 6 }"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password-old"
                  v-model="form.passwordOld"
                  :state="errors.length ? false : null"
                  :type="passwordFieldTypeOld"
                  placeholder="••••••••"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIconOld"
                    @click="togglePasswordVisibilityOld"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">
                <template v-if="errors[0]">
                  {{ errors[0] }}
                </template>
              </small>
              <small
                v-if="oldPasswordError"
                class="text-danger"
              >
                {{ oldPasswordError }}
              </small>
            </validation-provider>
          </b-form-group>

          <!-- Password ใหม่ -->
          <b-form-group
            :label="$t('passwordnew')"
            label-for="password-new"
            class="input-text"
          >
            <validation-provider
              v-slot="{ errors }"
              name="New Password"
              :rules="{ required: true, min: 6 }"
              vid="password"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password-new"
                  v-model="form.passwordNew"
                  :state="errors.length ? false : null"
                  :type="passwordFieldTypeNew"
                  placeholder="••••••••"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIconNew"
                    @click="togglePasswordVisibilityNew"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">
                <template v-if="errors[0]">
                  {{ errors[0] }}
                </template>
              </small>
            </validation-provider>
          </b-form-group>

          <!-- ยืนยัน Password อีกครั้ง-->
          <b-form-group
            :label="$t('passwordconfirm')"
            label-for="password-confirm"
            class="input-text"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Confirm Password"
              :rules="{ required: true, confirmed: 'password' }"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password-confirm"
                  v-model="form.passwordConfirm"
                  :state="errors.length ? false : null"
                  :type="passwordFieldTypeConfirm"
                  placeholder="••••••••"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIconConfirm"
                    @click="togglePasswordVisibilityConfirm"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">
                <template v-if="errors[0]">
                  {{ errors[0] }}
                </template>
              </small>
            </validation-provider>
          </b-form-group>

          <!-- Profile Image Upload -->
          <b-form-group
            :label="$t('uploadimage')"
            label-for="profile-image"
          >
            <input
              ref="fileInputImage"
              type="file"
              accept="image/*"
              @change="onFileChange"
            ><br>
            <img
              v-if="imageSrc"
              :src="imageSrc"
              alt="Profile Image"
              style="margin-top: 10px; width: 100px; height: 100px; object-fit: cover;"
            >
          </b-form-group>

          <b-form-group
            :label="$t('drawsignature')"
            label-for="signature-canvas"
          >
            <canvas
              ref="signatureCanvas"
              width="340"
              height="200"
              style="border: 1px solid #000; background-color: rgba(255, 255, 255, 0); touch-action: none;"
              @mousedown="startDrawing"
              @mousemove="draw"
              @mouseup="stopDrawing"
              @mouseleave="stopDrawing"
              @touchstart.prevent="startDrawing"
              @touchmove.prevent="draw"
              @touchend="stopDrawing"
            /><br>
            <button
              class="button-custom"
              @click="clearCanvas"
            >
              {{ $t('clearsignature') }}
            </button>
          </b-form-group>
          <br>
          <!-- Submit Button -->
          <b-button
            type="submit"
            variant="primary"
          >
            {{ $t('update') }}
          </b-button>
        </b-form>
      </validation-observer>
    </b-row>

    <!-- Confirm Update Modal -->
    <b-modal
      ref="confirmUpdateModal"
      hide-footer
      title="แจ้งเพื่อขอความยินยอม"
    >
      <div class="d-block text-left">
        <p>
          ระบบแจ้งซ่อมนี้มีการจัดเก็บลายเซ็นของท่าน
          เพื่อใช้ประกอบการแจ้งซ่อมและการอนุมัติการดำเนินการซ่อมเท่านั้น
        </p>
        <p>
          ข้อมูลลายเซ็นจะไม่ถูกนำไปใช้ในวัตถุประสงค์อื่น และจะถูกเก็บรักษาอย่างปลอดภัยตาม
          <strong>พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) พ.ศ. 2562</strong>
        </p>
        <p class="text-danger">
          ท่านยินยอมให้ระบบจัดเก็บและใช้ลายเซ็นตามวัตถุประสงค์ดังกล่าวหรือไม่?
        </p>
      </div>
      <div class="text-center">
        <b-button
          variant="secondary"
          @click="$refs.confirmUpdateModal.hide()"
        >
          ไม่ยินยอม
        </b-button>
        <b-button
          variant="primary"
          class="ml-2"
          @click="onSubmitConfirm"
        >
          ยินยอมและดำเนินการต่อ
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, min, confirmed } from 'vee-validate/dist/rules'
import {
  BRow, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BForm, BButton, BFormSelect,
} from 'bootstrap-vue'
import apiAuth from '@/services/auth'

extend('required', {
  ...required,
  message: 'This field is required',
})

extend('min', {
  ...min,
  message: 'Password must be at least {length} characters long',
})

extend('confirmed', {
  ...confirmed,
  message: 'Passwords do not match',
})

export default {
  components: {
    BRow,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    BButton,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    employee: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isEditing: false,
      form: {
        passwordOld: '',
        passwordNew: '',
        passwordConfirm: '',
      },
      oldPasswordError: '',
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      profileImageFile: null,
      imageSrc: null,
      imageSrcsig: null,
      originalSignature: null,
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeConfirm: 'password',
      isSignatureEdited: false,
      hasDrawn: false,
    }
  },
  computed: {
    userId() {
      return this.$store.getters.userId
    },
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconConfirm() {
      return this.passwordFieldTypeConfirm === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    this.resizeCanvas()
    window.addEventListener('resize', this.resizeCanvas)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas)
  },
  methods: {
    resizeCanvas() {
      const canvas = this.$refs.signatureCanvas
      if (!canvas) return

      const container = canvas.parentElement
      const containerWidth = container.clientWidth

      if (containerWidth < 340) {
        canvas.width = containerWidth - 20
      } else {
        canvas.width = 340
      }
      canvas.height = 200

      if (this.imageSrcsig) {
        this.drawOldSignature()
      }
    },
    togglePasswordVisibilityOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordVisibilityNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordVisibilityConfirm() {
      this.passwordFieldTypeConfirm = this.passwordFieldTypeConfirm === 'password' ? 'text' : 'password'
    },
    initializeForm(employeeData) {
      this.form = {
        passwordOld: '',
        passwordNew: '',
        passwordConfirm: '',
      }
      this.imageSrc = employeeData.imageUrl || null
      this.imageSrcsig = employeeData.signature
      this.originalSignature = employeeData.signature
      this.isSignatureEdited = false
      this.hasDrawn = false

      if (this.imageSrcsig && this.$refs.signatureCanvas) {
        this.$nextTick(() => {
          this.drawOldSignature()
        })
      }
    },

    async validateOldPassword() {
      try {
        const response = await apiAuth.post('auth/checkPassword', {
          userId: this.userId,
          password: this.form.passwordOld,
        })

        if (response.data.valid) {
          this.oldPasswordError = ''
          return true
        }

        this.oldPasswordError = 'Old password is incorrect'
        return false
      } catch (error) {
        console.error('Error validating password:', error)
        this.oldPasswordError = 'Error validating password'
        return false
      }
    },

    async onSubmit() {
      if (!await this.validateOldPassword()) return

      if (this.form.passwordNew !== this.form.passwordConfirm) {
        this.$bvToast.toast('New passwords do not match', {
          title: 'Error',
          variant: 'danger',
        })
        return
      }

      this.$refs.confirmUpdateModal.show()
    },

    async onSubmitConfirm() {
      const { userId } = this
      const formData = new FormData()
      formData.append('password', this.form.passwordNew)

      if (this.profileImageFile) {
        formData.append('image', this.profileImageFile)
      }

      if (this.isSignatureEdited) {
        if (this.imageSrcsig) {
          formData.append('signature', this.imageSrcsig)
        } else {
          formData.append('signature', '')
        }
      } else if (this.originalSignature) {
        formData.append('signature', this.originalSignature)
      } else {
        formData.append('signature', '')
      }

      try {
        const response = await apiAuth.put(`auth/userReset/${userId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (response.status !== 200) throw new Error('Password update failed')

        this.$refs.confirmUpdateModal.hide()
        this.$bvToast.toast(this.$t('passwordUpdateSuccess'), {
          title: this.$t('success'),
          variant: 'success',
        })

        this.form.passwordOld = ''
        this.form.passwordNew = ''
        this.form.passwordConfirm = ''
        this.$refs.formValidator.reset()
        this.$refs.fileInputImage.value = null
        this.imageSrc = null
        this.hasDrawn = false
        const canvas = this.$refs.signatureCanvas
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
      } catch (error) {
        this.$refs.confirmUpdateModal.hide()
        this.$bvToast.toast(`Error updating password: ${error.message}`, {
          title: 'Error',
          variant: 'danger',
        })
        console.error(error)
      }
    },

    onFileChange(event) {
      this.profileImageFile = event.target.files[0]
      this.imageSrc = this.profileImageFile ? URL.createObjectURL(this.profileImageFile) : null
    },

    startDrawing(event) {
      this.isDrawing = true
      this.isSignatureEdited = true
      const canvas = this.$refs.signatureCanvas
      const rect = canvas.getBoundingClientRect()

      const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX
      const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY

      this.lastX = clientX - rect.left
      this.lastY = clientY - rect.top
    },
    draw(event) {
      if (!this.isDrawing) return
      this.isSignatureEdited = true
      this.hasDrawn = true
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      const rect = canvas.getBoundingClientRect()

      const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX
      const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY

      const x = clientX - rect.left
      const y = clientY - rect.top

      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      ctx.lineTo(x, y)
      ctx.strokeStyle = '#000'
      ctx.lineWidth = 2
      ctx.stroke()

      this.lastX = x
      this.lastY = y
    },
    stopDrawing() {
      if (this.isDrawing) {
        this.isSignatureEdited = true
        this.convertCanvasToImage()
      }
      this.isDrawing = false
    },
    clearCanvas(event) {
      event.preventDefault()
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.imageSrcsig = null

      if (this.originalSignature || this.hasDrawnOnCanvas()) {
        this.isSignatureEdited = true
      } else {
        this.isSignatureEdited = false
      }
    },
    hasDrawnOnCanvas() {
      return this.hasDrawn
    },
    convertCanvasToImage() {
      const canvas = this.$refs.signatureCanvas
      this.imageSrcsig = canvas.toDataURL('image/png')
    },
    drawOldSignature() {
      if (!this.originalSignature) return

      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.src = this.originalSignature

      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height) // Clear canvas
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height) // Draw old signature

        this.imageSrcsig = this.originalSignature
        this.isSignatureEdited = false
      }
    },
  },
}
</script>

  <style scoped>
  .auth-wrapper {
    padding: 20px;
  }
  .input-text {
    width: 21vw;
    max-width: 500px;
    min-width: 50px;
    box-sizing: border-box;
  }

  .button-custom {
    margin-top: 10px;
    padding: 5px 10px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    cursor: pointer;
  }

  .button-custom:hover {
    background-color: #e9ecef;
  }

  @media (max-width: 768px) {
    .input-text {
      width: 400px;
      min-width: 150px;
    }
    canvas {
      width: 340px;
      height: auto;
    }
  }

  @media (max-width: 360px) {
    .input-text {
      max-width: 230px;
      min-width: 50px;
      box-sizing: border-box;
    }
    canvas {
      width: 230px;
      height: auto;
    }
  }

  canvas {
    max-width: 100%;
    height: auto;
  }
  </style>
